import React from 'react';
import GenericCard from './components/Card';
import { Col, Row } from 'reactstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import uuid from 'uuid';

class GeneratePolicy extends React.Component {
	state = {
		expanded: null,
		privacyPolicyPercentage: '(50% Complete, click the drop down to complete policy)',
		isValid: null,
		policyMessage: 'Generate Policy Now',
		question1: "",
		question2: "",
		open: false,
	};

	componentWillMount () {
		return this.props.user ? null : this.props.history.push('/unauthorized');
	}

	handleOpen = () => {
		this.setState({ open: true });
	};

	handleClose = () => {
		this.setState({ open: false });
	};

	handleChange = panel => (event, expanded) => {
		this.setState({
			expanded: expanded ? panel : false,

		});
	};
	handleQuestion1Change = (evt) => {
		this.setState({ question1: evt.target.value });
	}

	handleQuestion2Change = (evt) => {
		this.setState({ question2: evt.target.value });
	}
	handlePrivacySubmit = () => {

		this.setState({
			privacyPolicyPercentage: '(100% Complete)',
			policyMessage: 'Policy Generated'
		});
		alert(`Your Privacy Policy has been Generated`);
		this.handleClose();
	}
	handleEmailSubmit = () => {
		alert(`Your Email Policy  has been Generated`);
	}
	handlePasswordSubmit = () => {
		alert(`Your Password Policy has been Generated`);
	}
	handleUseSubmit = () => {
		alert(`Your Acceptable Use Policy has been Generated`);
	}
	render () {
		const policies = [
			{
				name: 'Incident Response',
				fields: {
					img: 'mail.png',
					progress: 'Completion Progress : 100%',
					description: `An incident response policy is a plan outlying 
					organization's response to an information security incident.`,
					template: 'incident',
					questionnaire: 'incident-policy-questions',
				},
			},
			{
				name: 'GDPR Data Protection',
				fields: {
					img: 'privacy.png',
					progress: 'Completion Progress : 100%',
					description: `This policy sets out how we intend to comply with 
					data protection legislation and handle personal and sensitive information`,
					template: '',
				},
			},
			{
				name: 'Privacy',
				fields: {
					img: 'password.png',
					progress: 'Completion Progress : 100%',
					description: `This policy discloses some or all of the ways a 
					party gathers, uses, discloses, and manages a customer or client's data`,
					template: 'privacy',
				},
			},
			{
				name: 'Third Party',
				fields: {
					img: 'privacy.png',
					progress: 'Completion Progress : 100%',
					description: `This policy establishes rules and operating parameters 
					for third party vendors' access to company information`,
					template: 'thirdparty',
					questionnaire: 'third-party-policy-questions'
				},
			},
			{
				name: 'Acceptable Use',
				fields: {
					img: 'password.png',
					progress: 'Completion Progress : 100%',
					description: `A set of rules applied by the owner, creator or 
					administrator of a service, that sets guidelines as to how it should be used.`,
					template: '',
				},
			},
		]


		let policyComponents = policies.map((p, idx) => {
			return <Col md={3} key={uuid()}> <GenericCard {...p} /> </Col>
		})


		return (
			<div className="container-fluid no-breadcrumbs with-max width-md chapter">
				{
					<div>
						<div className="page-title">
							<Row>
								<Col md={12}>
									<h3 className='page-title'>{this.props.compliance} Policies</h3>
									<h3 className='page-subhead subhead'>Select Policy from the list below!</h3>
								</Col>
							</Row>

							<div className="container">
								<Row>
									{policyComponents}
								</Row>
							</div>
						</div>
					</div>
				}
			</div>

		);
	}
}

function mapStateToProps (state) {
	return {
		user: state.auth.user
	}
}

export default connect(mapStateToProps)(withRouter(GeneratePolicy));






// WEBPACK FOOTER //
// ./src/components/policies/Policies.js